import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { useSelector } from 'react-redux';
import WYSIWYGEditor from '../Common/WYSIWYGEditor';


const ModalModificarPlantilla = ({ isOpen, toggle, selectedPlantilla, onSave }) => {
    const [formData, setFormData] = useState({ name: '', content: '' });
    const tenantId = useSelector((state) => state.Context.tenantId);


    useEffect(() => {
        if (selectedPlantilla) {
            setFormData({ name: selectedPlantilla.name, content: selectedPlantilla.content });
        }
    }, [selectedPlantilla]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSave = () => {
        formData.tenantId = tenantId
        onSave(formData);
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Modificar Plantilla</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="name">Nombre</Label>
                        <Input type="text" name="name" id="name" value={formData.name} onChange={handleChange} disabled={true} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="content">Contenido</Label>
                        <WYSIWYGEditor
                            value={formData.content}
                            onChange={(value) => setFormData({ ...formData, content: value })}
                        />
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSave}>Guardar</Button>
                <Button color="secondary" onClick={toggle}>Cancelar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalModificarPlantilla;